/* Card.jsx */
import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from "react-redux";
import { deleteMemeFB } from '../Redux/modules/words';


const Card = () => {
const dispatch = useDispatch();
const pwRef = useRef();
const memeList = useSelector((state) => state.memeReducer.list);
console.log(memeList)

const [password, setPassword] = useState();

//콜백함수
const onChangeHandler = (event) => {
const valuePW = event.target.value;
  setPassword(valuePW);
}

  const memes = memeList.map((value, index)=><CardContainer key={index}>
    <Img src={value.url} alt="" />
    <TextContainer>
      <TextLine>{value.name}</TextLine>
      <TextLine>{value.desc}</TextLine>
      <DeleteButton onClick={()=> {
        password === value.pw ?
        dispatch(deleteMemeFB(memeList[index].id)) :
        alert("남이 올린거를 지우려고 하시면 안됩니다!")
        }}
        >
        🗑
      </DeleteButton>
      <input type="text" ref={pwRef} onChange={onChangeHandler} />
    </TextContainer>
  </CardContainer>)
  return (
  <>
    {memes}
  </>
  )
  }

  export default Card;



  const CardContainer = styled.div`
  border: 1px solid white;
  display: flex;
  /* position: relative; */
  border-radius: 30px;
`;

const Img = styled.img`
  width:50%;
  height:90%;
  margin:auto;
  border-radius: 30px;
  @media screen and (max-width: 400px) {
      width: 100%;
  }
`;

const DeleteButton = styled.div`
  border: 1px solid white;
  border-radius: 100%;
  width: 60px;
  height: 60px;
  background-color: #000;
  font-size: 60px;
  color: #fff;
  text-align: center;
  margin: 30px;
`;

const TextContainer = styled.div`
    width: 40%;
    height: 80%;
    margin: auto;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    @media screen and (max-width: 400px) {
      display: none;
  }
`;

const TextLine = styled.div`
    width: 80%;
    border-bottom: 2px solid white;
    font-size: 2rem;
    text-align: center;
    margin-top: 40px;
    &:nth-child(2){
        font-size: 1.2rem;
        border-bottom: none;
    }
`;